export const translations = {
  rtv: {
    pt: "Código RTV",
    en: "RTV Code",
    de: "RTV-Code",
    es: "Código RTV",
  },
  rtv_gr: {
    pt: "RTV/GR",
    en: "RTV/GR",
    de: "RTV/GR",
    es: "RTV/GR",
  },
  regional: {
    pt: "Regional",
    en: "Regional",
    de: "Regional",
    es: "Regional",
  },
};
